import { forwardRef, HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

const Container = forwardRef<HTMLDivElement, Props>(
  ({ className, size, children, ...props }, ref) => {
    const sizeClasses = {
      sm: 'max-w-screen-sm',
      md: 'max-w-screen-md',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl',
      '2xl': 'max-w-screen-2xl',
    }

    return (
      <div
        ref={ref}
        className={cn(
          'mx-auto w-full sm:px-6 lg:px-8',
          size && sizeClasses[size],
          className
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Container.displayName = 'Container'

interface Props extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
}

export default Container
